module.exports = __webpack_public_path__ + "img/taketomi_8.01c69fab.jpg";